import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

export default function InvoiceRecipients(props) {
	const [invoiceRecipients, setInvoiceRecipients] = useState(props.billing_config.invoice_recipients)
	const handleDeleteRecipient = (id) => {
		const newInvoices = invoiceRecipients.filter(el=>el.id!==id)
		setInvoiceRecipients([...newInvoices])
	}
	return (
		<Row className="pt-3">
			<Col xs={12} lg={7} xl={5}>
				<Row>
					<Col>
						<p className="px-4 px-lg-5 f16 visby-medium primary">Invoice Recipients</p>
					</Col>
				</Row>
				<Row>
					<Col>
						<p className="px-4 px-lg-5 pb-2 f14 primary">
							{" "}
							Add emails below that will receive invoices for this client.
						</p>
					</Col>
				</Row>
				<Form.Group>
					{invoiceRecipients.map(
						(invoiceRecipient, index) => {
							return (
								<div key={invoiceRecipient.id?invoiceRecipient.id:uuidv4()}>
									<Row>
										<Col>
											<div className="px-4 px-lg-5 d-flex justify-content-center">
												<input type="hidden" name="[invoice_recipients][][id]" value={invoiceRecipient.id?invoiceRecipient.id:uuidv4()}/>
												<Form.Control
													size="sm"
													name={`[invoice_recipients][][email]`}
													defaultValue={invoiceRecipient.email}
													className="tableSearch mr-2 mb-2 col-8"
													placeholder=""
												/>
												<i className = "fas fa-minus-circle" onClick={()=>handleDeleteRecipient(invoiceRecipient.id)}></i>
											</div>
										</Col>
									</Row>
								</div>
							);
						}
					)}
				</Form.Group>
				<Row>
					<Col>
						<div className="px-4 px-lg-5">
							<Button
								className="mb-3 py-1 text-center"
								variant="success"
								onClick={(e) => setInvoiceRecipients([...invoiceRecipients,{id:uuidv4(), email:""}])}
							>
								+ Add email
							</Button>
						</div>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
